import React from "react"
import types from "prop-types"
import { XIcon } from "shared/icons"

const DeleteConditionButton = ({ deleteCondition, className = "", buttonLabel = "delete" }) => {
  const handleOnClick = (event) => {
    event.preventDefault()
    deleteCondition()
  }

  return (
    <button onClick={handleOnClick} aria-label={buttonLabel}>
      <XIcon
        className={className}
        ariaHidden
      />
    </button>
  )
}
DeleteConditionButton.propTypes = {
  className: types.string,
  deleteCondition: types.func.isRequired,
  buttonLabel: types.string,
}

export default DeleteConditionButton
